import modalRoute from './modal-routes';

export default {
	functional: true,
	name: 'Modal',
	props: {
		type: {
			type: String,
			required: true,
		},
		closeBtnPos: {
			top: Number,
			right: Number,
			value: String, // 有四种取值：
			// 'right' (默认)：右上角 30px 距离，大小 0.25 rem;
			// 'left'：左上角 30px 距离，大小 0.25 rem;
			// 'bottom'：底部居中，大小 0.4 rem;
			// 'top'：顶部居中， 距离，大小 0.25 rem;
		},
		childType: Number,
		closeFn: {
			type: Function,
			required: true,
		},
		btnFn: Function,
		clickEmptyCloseModal: {
			// 配置是否需要点击空白处关闭弹窗
			type: Boolean,
			default: false,
		},
		// 是否展示遮照
		overlay: {
			type: Boolean,
			default: true,
		},
	},
	render(h, context) {
		// const htmlElement = document.getElementsByTagName('html')[0];
		const htmlElement = document.body;
		htmlElement.style.overflow = 'hidden';

		const { props, data } = context;
		const content = modalRoute[props.type];

		const closeBtnConf = {
			class: 'close-btn right',
			attrs: {
				// width: 25,
			},
			on: {
				click() {
					closeFn();
				},
			},
			domProps: {
				// eslint-disable-next-line global-require
				src: require('@/assets/ky-close.png'),
			},
		};

		if (props.closeBtnPos) {
			const { top, right, bottom, value } = props.closeBtnPos;

			closeBtnConf.style = top ? (closeBtnConf.style = { top: `${top}rem` }) : {};

			right && Object.assign(closeBtnConf.style, { right: `${right}rem` });

			bottom && Object.assign(closeBtnConf.style, { bottom: `${bottom}rem` });

			if (value) {
				closeBtnConf.class = closeBtnConf.class.replace('right', value);
			}
		}

		const closeFn = () => {
			htmlElement.style.cssText = htmlElement.style.cssText.replace('overflow: hidden;', ''); // 'scroll';
			props.closeFn();
		};

		const btnFn = (...params) => {
			htmlElement.style.cssText = htmlElement.style.cssText.replace('overflow: hidden;', ''); // 'scroll';

			if (props.btnFn) {
				props.btnFn.call(null, ...params);
			} else {
				props.closeFn();
			}
		};
		const childProp = {
			handleBtn: btnFn,
			handleClose: closeFn,
			child: props.childType,
			...data.attrs,
		};
		// 点击空白处关闭弹窗
		if (props.clickEmptyCloseModal) {
			setTimeout(() => {
				document.getElementById('modal-wrapper-new').addEventListener(
					'click',
					(e) => {
						if (e.target.id === 'modal-wrapper-new') {
							closeFn();
						}
					},
					false
				);
			});
		}

		const showOverlay = props.overlay;

		console.log(`showOverlay`, showOverlay);
		return h(
			'transition',
			{
				attrs: {
					name: 'modal',
				},
			},
			[
				h(
					'div',
					{
						class: ['modal-wrapper-new', showOverlay ? 'overlay' : ''],
						attrs: {
							id: 'modal-wrapper-new',
						},
					},
					[
						h(
							'main',
							{
								class: 'modal-content-new',
							},
							[
								h('img', closeBtnConf),
								h(content, {
									tag: 'component',
									props: childProp,
								}),
							]
						),
					]
				),
			]
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/modal/index.js